

/// <reference path="MemoLog.ts" />

// Generated class EventLog_ManagedObject

class EventLog_ManagedObject extends MemoLog
{
}
